import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { CollaborationSessions } from '../../helpers/schema';

export const schema = z.object({
  id: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  session: Selectable<CollaborationSessions>;
};

export const getSession = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const params = new URLSearchParams({ id: input.id });
  const result = await fetch(`/_api/sessions/get?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const text = await result.text();
    if (!text) {
      throw new Error(`Request failed with status ${result.status}`);
    }
    try {
      const errorObject = superjson.parse<{ error: string }>(text);
      throw new Error(errorObject.error);
    } catch (parseError) {
      throw new Error(`Request failed with status ${result.status}: ${text.substring(0, 100)}`);
    }
  }
  return superjson.parse<OutputType>(await result.text());
};
